import axios from 'axios';

let base = '/yhpczl/mgr';
export const mgrlogin = params => { return axios.get(`${base}/v1/mgrlogin`, { params: params } ); };
export const changePwd = params => { return axios.post(`${base}/v1/changePwd`, params ); };

// 获取选项字典表
export const getparamsByType = params => { return axios.get(`${base}/v1/getparamsByType`, { params: params }); };

// 企业管理
export const deleteCompany = params => { return axios.post(`${base}/v1/deleteCompany`, params ); };
export const companyPageList = params => { return axios.get(`${base}/v1/companyPageList`, { params: params }); };
export const addCompany = params => { return axios.post(`${base}/v1/addCompany`, params ); };
export const editCompany = params => { return axios.post(`${base}/v1/editCompany`, params ); };
export const editService = params => { return axios.post(`${base}/v1/editService`, params ); };
export const companyPageListdc = params => { return axios.get(`${base}/v1/companyPageListdc`, { params: params }); };

// 人员管理
export const memberPageList = params => { return axios.get(`${base}/v1/memberPageList`, { params: params }); };
export const editMemberInfo = params => { return axios.post(`${base}/v1/editMemberInfo`, params ); };
export const deleteMember = params => { return axios.post(`${base}/v1/deleteMember`, params ); };
export const addMember = params => { return axios.post(`${base}/v1/addMember`, params ); };
export const memberPageListdc = params => { return axios.get(`${base}/v1/memberPageListdc`, { params: params }); };

// 资料管理
export const companyFilePageList = params => { return axios.get(`${base}/v1/companyFilePageList`, { params: params }); };
export const addCompanyFile = params => { return axios.post(`${base}/v1/addCompanyFile`, params ); };
export const deletecompanyFile = params => { return axios.post(`${base}/v1/deletecompanyFile`, params ); };
export const companyFilePageListdc = params => { return axios.get(`${base}/v1/companyFilePageListdc`, { params: params }); };


// 协议客户管理（企业管理员）
export const companyGuestPageList = params => { return axios.get(`${base}/v1/companyGuestPageList`, { params: params }); };
export const addCompanyGuest = params => { return axios.post(`${base}/v1/addCompanyGuest`, params ); };
export const updateCompanyGuest = params => { return axios.post(`${base}/v1/updateCompanyGuest`, params ); };

// 车辆管理
export const companyCarPageListdc = params => { return axios.get(`${base}/v1/companyCarPageListdc`, { params: params }); };

export const companyCarPageList = params => { return axios.get(`${base}/v1/companyCarPageList`, { params: params }); };
export const addCompanyCar = params => { return axios.post(`${base}/v1/addCompanyCar`, params ); };
export const deleteCompanyCar = params => { return axios.post(`${base}/v1/deleteCompanyCar`, params ); };

//隐患排查-计划
export const selfCheckPlanList = params => { return axios.get(`${base}/v1/selfCheckPlanList`, { params: params }); };
export const addSelfCheckPlan = params => { return axios.post(`${base}/v1/addSelfCheckPlan`, params ); };
export const allWorkerList = params => { return axios.get(`${base}/v1/allWorkerList`, { params: params }); };
export const deleteSelfCheckPlan = params => { return axios.post(`${base}/v1/deleteSelfCheckPlan`, params ); };

//隐患排查-记录
export const selfCheckRecordList = params => { return axios.get(`${base}/v1/selfCheckRecordList`, { params: params }); };
export const companyCheckDetailList = params => { return axios.get(`${base}/v1/companyCheckDetailList`, { params: params }); };
export const updateSelfCheckZgInfo = params => { return axios.post(`${base}/v1/updateSelfCheckZgInfo`, params ); };
export const updateSelfCheckYsInfo = params => { return axios.post(`${base}/v1/updateSelfCheckYsInfo`, params ); };
export const addRecordPic = params => { return axios.post(`${base}/v1/addRecordPic`, params ); };

export const addSelfCheckRecord = params => { return axios.post(`${base}/v1/addSelfCheckRecord`, params ); };

//隐患排查-上报
export const selfCheckReportList = params => { return axios.get(`${base}/v1/selfCheckReportList`, { params: params }); };
export const addSelfCheckReport = params => { return axios.post(`${base}/v1/addSelfCheckReport`, params ); };
export const addReportPic = params => { return axios.post(`${base}/v1/addReportPic`, params ); };
export const updateZgInfo = params => { return axios.post(`${base}/v1/updateZgInfo`, params ); };
export const updateYsInfo = params => { return axios.post(`${base}/v1/updateYsInfo`, params ); };

//培训管理
export const companyTrainPageList = params => { return axios.get(`${base}/v1/companyTrainPageList`, { params: params }); };
export const addCompanyTrain = params => { return axios.post(`${base}/v1/addCompanyTrain`, params ); };
export const deleteCompanyTrain = params => { return axios.post(`${base}/v1/deleteCompanyTrain`, params ); };

//监督检查
export const gjCheckList = params => { return axios.get(`${base}/v1/gjCheckList`, { params: params }); };
export const updateYhOK = params => { return axios.post(`${base}/v1/updateYhOK`, params ); };
export const gjCheckDetailList = params => { return axios.get(`${base}/v1/gjCheckDetailList`, { params: params }); };
export const updateCorrectDeadTime = params => { return axios.post(`${base}/v1/updateCorrectDeadTime`, params ); };
export const updateCorrectInfo = params => { return axios.post(`${base}/v1/updateCorrectInfo`, params ); };
export const updateReviewInfo = params => { return axios.post(`${base}/v1/updateReviewInfo`, params ); };
export const updateReviewNG = params => { return axios.post(`${base}/v1/updateReviewNG`, params ); };

//20260320简化版gov检查记录
export const govCheckPageList = params => { return axios.get(`${base}/v1/govCheckPageList`, { params: params }); };
export const addGovCheck = params => { return axios.post(`${base}/v1/addGovCheck`, params ); };
export const updateGovCheckInfo = params => { return axios.post(`${base}/v1/updateGovCheckInfo`, params ); };

//统计分析
export const safefilecheckSumPage = params => { return axios.get(`${base}/v1/safefilecheckSumPage`, { params: params }); };


export const selfcheckSumPage = params => { return axios.get(`${base}/v1/selfcheckSumPage`, { params: params }); };
export const recordMonthPage = params => { return axios.get(`${base}/v1/recordMonthPage`, { params: params }); };
export const reportMonthPage = params => { return axios.get(`${base}/v1/reportMonthPage`, { params: params }); };

export const gjcheckSumPage = params => { return axios.get(`${base}/v1/gjcheckSumPage`, { params: params }); };

//系统管理-栏目管理
export const getGwCheckItem = params => { return axios.get(`${base}/v1/getGwCheckItem`, { params: params }); };
export const updateGwCheckItem = params => { return axios.post(`${base}/v1/updateGwCheckItem`, params ); };

//系统管理-用户管理
export const getAccountList = params => { return axios.get(`${base}/v1/getAccountList`, { params: params }); };
export const updateAccount = params => { return axios.post(`${base}/v1/updateAccount`, params ); };
export const resetAccountpwd = params => { return axios.post(`${base}/v1/resetAccountpwd`, params ); };

//通知管理
export const allCompanyList = params => { return axios.get(`${base}/v1/allCompanyList`, { params: params }); };
export const getNoticeListPage = params => { return axios.get(`${base}/v1/getNoticeListPage`, { params: params }); };
export const getcompanyNoticeListPage = params => { return axios.get(`${base}/v1/getcompanyNoticeListPage`, { params: params }); };

export const addNotice = params => { return axios.post(`${base}/v1/addNotice`, params ); };
export const deleteNotice = params => { return axios.post(`${base}/v1/deleteNotice`, params ); };
export const addCompanyFiles = params => { return axios.post(`${base}/v1/addCompanyFiles`, params ); };

export const getNoticeFileList = params => { return axios.get(`${base}/v1/getNoticeFileList`, { params: params }); };
export const noticeCompanyList = params => { return axios.get(`${base}/v1/noticeCompanyList`, { params: params }); };

//企业首页显示未读通知数量
export const noticeUnreadCount = params => { return axios.get(`${base}/v1/notice/unreadCount`, { params: params }); };

export const updateNoticeCompanyStatus = params => { return axios.post(`${base}/v1/updateNoticeCompanyStatus`, params ); };



// WEBPACK FOOTER //
// ./src/api/api.js